import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PreferencePage } from "preference-spa";

const clientBasedClassName = {
  "urn:pe:plus": "m1",
  "urn:pe:cli": "m2",
  "urn:pe:vnsdjbv": "m3"
};

function PreferenceComponent() {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const userID = queryParams.get('userID');
  const token = queryParams.get('token');
  const clientId = queryParams.get('clientId');
  
  const [isLoading, setIsLoading] = useState(false);
  const [successRespCount, setSuccessRespCount] = useState(0);
  const [errorRespCount, setErrorRespCount] = useState(0);

  const piSessionObj = {
    userId: () => userID || "",
    currentToken: () => token || ""
  };

  const onSuccess = () => { 
    setSuccessRespCount(prevCount => prevCount + 1);
   };
  const onFailure = () => {
    setErrorRespCount(prevCount => prevCount + 1);
   };

   useEffect(() => {
    console.log({errorRespCount}, {successRespCount});
    if(successRespCount >= 2) {
      history.push({
        pathname: '/confirmation',
        state: { userID, token, clientId }
      });
    }
    if(errorRespCount >= 1) {
      history.push({
          pathname: '/error', 
          state: { userID, token, clientId }
        });
      }
    }, [successRespCount, errorRespCount])

  return (
      <div className="App">
        {isLoading ? 'Loading...' :
         
          <PreferencePage 
            allowChanges={true} 
            onSuccess={onSuccess} 
            onFailure={onFailure} 
            piSessionObj={piSessionObj} 
            customClass={clientBasedClassName[clientId]}
          />
        }
      </div>
  );
}

export default PreferenceComponent;
